import { render, staticRenderFns } from "./ThumbsSwiper.vue?vue&type=template&id=62cb05ec&scoped=true"
import script from "./ThumbsSwiper.vue?vue&type=script&lang=js"
export * from "./ThumbsSwiper.vue?vue&type=script&lang=js"
import style0 from "./ThumbsSwiper.vue?vue&type=style&index=0&id=62cb05ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cb05ec",
  null
  
)

export default component.exports